export default class PostGallery {
  constructor() {
    if (!this.setVars()) return;

    this.setEvents();
  }

  setVars() {
    this.sliderContainer = document.querySelector('.gallery');
    if (!this.sliderContainer) return false;
    this.slideElements = this.sliderContainer.querySelectorAll('.gallery-item');
    if (!this.slideElements.length) return false;

    this.currentSlide = 0;
    this.previousSlideValue = null;
    this.slideShowInterval = 300000;
    this.timeOut = setInterval(this.autoSlides.bind(this), this.slideShowInterval);

    return true;
  }

  setEvents() {
    this.slideElements[0].classList.add('visible');
    this.resetLinks();
    this.createButtons();
  }

  resetLinks() {
    this.sliderContainer.querySelectorAll('a').forEach((singleElement) => {
      singleElement.addEventListener('click', (e) => {
        e.preventDefault();
      });
    });
  }

  changeSlide(event) {
    if (event.target.dataset.control == 'left') {
      this.previousSlideValue = this.currentSlide;
      this.currentSlide = (--this.currentSlide < 0)
        ? this.currentSlide = this.slideElements.length - 1
        : this.currentSlide;
    } else {
      this.previousSlideValue = this.currentSlide;
      this.currentSlide = (++this.currentSlide > this.slideElements.length - 1)
        ? this.currentSlide = 0
        : this.currentSlide;
    }

    this.slideStatus.innerHTML = `${this.currentSlide + 1}/${this.slideElements.length}`;

    clearTimeout(this.timeOut);
    this.timeOut = setInterval(this.autoSlides.bind(this), this.slideShowInterval);

    this.slideElements[this.previousSlideValue].classList.remove('visible');
    this.slideElements[this.currentSlide].classList.add('visible');
  }

  autoSlides() {
    this.pickSlide((this.currentSlide + 1 > this.slideElements.length - 1)
      ? 0
      : this.currentSlide + 1);
  }

  createButtons() {
    for (let i = 0; i < 2; i++) {
      const singleButton = document.createElement('div');
      singleButton.classList.add('gallery__control');
      singleButton.dataset.control = (i === 0) ? 'left' : 'right';
      singleButton.addEventListener('click', this.changeSlide.bind(this));
      this.sliderContainer.appendChild(singleButton);
    }

    this.slideStatus = document.createElement('div');
    this.slideStatus.classList.add('gallery__slideStatus');
    this.slideStatus.innerHTML = `1/${this.slideElements.length}`;
    this.sliderContainer.appendChild(this.slideStatus);
  }
}
